<template>
  <v-container :fluid="true" class="page_container">
    <div class="partner__title" v-if="newPartners.length > 0 && !isLoadingNewPartners">
        <span class="partner__title--text">
          Новые партнеры
        </span>
    </div>
    <div
        class="partner__content"
        :class="'mb-3 mb-sm-12'"
        v-if="newPartners.length > 0 && !isLoadingNewPartners"
    >
      <PartnerCard
          id="newPartners"
          :style="partnerCardStyle"
          v-if="newPartners.length > 0 && !isLoadingNewPartners"
          :partners="newPartners"
          justify_row="space-around"
      />
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div class="partner__next" v-if="((newPartners.length > 1 && $vuetify.display.width < 780) || (newPartners.length > 2 && $vuetify.display.width < 1120) || (newPartners.length > 3 && $vuetify.display.width <= 1920) || (newPartners.length > 4 && $vuetify.display.width > 1920))  && !isLoadingNewPartners">
        <v-btn color="#376FFE" height="55" width="212" class="partner__next_btn" :disabled="isLoadingNewPartners" @click="new_partners_more = !new_partners_more">
          <span v-if="!new_partners_more">
             ПОКАЗАТЬ ЕЩЁ
          </span>
          <span v-else>
             СКРЫТЬ
          </span>
        </v-btn>
      </div>
    </div>
    <div class="partner__title">
      <span class="partner__title--text" v-if="!search_panel && $vuetify.display.width < 769 || $vuetify.display.width >= 769">
        Все партнеры
      </span>
      <v-row no-gutters align="start" justify="end">
        <div v-if="region_panel && !filter_panel && !search_panel" class="search__field">
          <v-autocomplete
              class="search__field_input"
              ref="region-field-input"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              item-title="text"
              item-value="value"
              label="Выберите регион партнера"
              no-data-text="Нет подходящих данных"
              :items="selectors.partnersRegions"
              v-model="filters.region"
              :loading="isLoading"
              :disabled="isLoading"
              @update:model-value="clickRegion"
          >
            <template v-slot:label>
              <div class="label__text">
                Регион
              </div>
            </template>
            <template v-slot:prepend-item>
              <v-list-item @click="filterPartnersToRegion(true)">
                <v-list-item-title>Мой регион</v-list-item-title>
              </v-list-item>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeRegion" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 32 : 20" color="#3254B9" class="search_icon mr-1" @click="openRegion" v-else-if="!region_panel && !filter_panel && !search_panel">public</v-icon>
        <div v-if="filter_panel && !search_panel && !region_panel" class="search__field">
          <v-autocomplete
              class="search__field_input"
              ref="filter-field-input"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              item-title="text"
              item-value="value"
              label="Выберите тэг партнера"
              no-data-text="Нет подходящих данных"
              :items="selectors.partnersTags"
              v-model="filters.tag"
              :loading="isLoading"
              :disabled="isLoading"
              @update:model-value="clickFilter"
          >
            <template v-slot:label>
              <div class="label__text">
                Категории
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeFilter" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
          </v-autocomplete>
        </div>
        <v-icon :size="$vuetify.display.width >= 769 ? 30 : 20" color="#3254B9" class="search_icon mr-2" @click="openFilter" v-else-if="!region_panel && !filter_panel && !search_panel">$custom_filter</v-icon>
        <div v-if="search_panel && !filter_panel && !region_panel" class="search__field">
          <v-text-field
              v-model="search.value"
              @keydown.enter="clickSearch"
              ref="search-field-input"
              class="search__field_input"
              color="#3254B9"
              base-color="#313743"
              variant="outlined"
              placeholder="Введите текст и нажмите кнопку поиска"
          >
            <template v-slot:label>
              <div class="search__field_label">
                Поиск
              </div>
            </template>
            <template v-slot:append>
              <div class="search__field_label" @click="closeSearch" style="cursor: pointer">
                <v-icon :size="$vuetify.display.width >= 769 ? 45 : 30" color="#3254B9" class="mr-n2">close</v-icon>
              </div>
            </template>
            <template v-slot:append-inner>
              <v-icon size="20" class="search_icon" @click="clickSearch" v-if="$vuetify.display.mdAndDown">$custom_search</v-icon>
            </template>
          </v-text-field>
        </div>
        <v-icon v-else-if="!filter_panel && !search_panel && !region_panel" :size="$vuetify.display.width >= 769 ? 30 : 20" class="search_icon" @click="openSearch">$custom_search</v-icon>
      </v-row>
    </div>
    <v-row no-gutters class="mb-5" justify="end" v-if="$vuetify.display.width > 1596">
      <div v-for="(item, i) in selectors.partnersTags" :key="i">
        <v-btn color="#376FFE" variant="flat" class="filter-btn" @click="filterPartnersToCategory(item.value)" v-if="item.is_primary">{{item.text}}</v-btn>
      </div>
      <v-btn color="#376FFE" variant="flat" class="filter-btn" @click="filterPartnersToCategory()">все партнеры</v-btn>
    </v-row>
    <div
        class="partner__content"
    >
      <PartnerCard
        v-if="partners.length > 0 && !isLoading"
        :partners="partners"
        justify_row="space-around"
        @changeCategory="filterPartnersToCategory"
      />
      <div v-else-if="partners.length === 0 && !isLoading">
        <NoData/>
      </div>
      <div v-else>
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
      <div class="partner__next" v-if="partners.length > 0 && !isLoading && getPartnersNext !== null && !isSubLoading">
        <v-btn color="#376FFE" height="55" width="212" class="partner__next_btn" :disabled="isLoading || isSubLoading" @click="loadNextItems()">
          ПОКАЗАТЬ ЕЩЁ
        </v-btn>
      </div>
      <div v-if="isSubLoading">
        <v-row no-gutters justify="center" align="center" style="height: 25vh; min-height: 200px">
          <fulfilling-square-spinner
              :animation-duration="4000"
              :size="100"
              color="#34347C"
          />
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
import { defineComponent } from 'vue'
import PartnerCard from "@/modules/templates/PartnerCard.vue"
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin"
import names from "@/modules/core/routers/names"
import { mapActions, mapGetters } from "vuex"
import { FulfillingSquareSpinner } from "epic-spinners"
import NoData from "@/modules/templates/NoData.vue"

export default defineComponent({
  name: "Partners",
  components: {
    NoData,
    PartnerCard,
    FulfillingSquareSpinner
  },
  mixins: [PaginatedDataMapperMixin],
  data () {
    return {
      isLoading: true,
      isNewPartnersLoading: true,
      isSubLoading: false,
      partners: [],
      newPartners: [],
      search_panel: false,
      filter_panel: false,
      region_panel: false,
      search: {
        parameter: 'search',
      },
      filters: {
        tag: null,
        region: null,
        home_region: null,
      },
      selectors: {
        partnersTags: [],
        partnersRegions: [],
      },
      search_local_value: undefined,
      new_partners_more: false
    }
  },
  computed: {
    partnerCardStyle () {
      let height = 'auto'
      if (document.getElementById('newPartners')) {
        height = document.getElementById('newPartners').scrollHeight + 'px'
      }
      return {
        maxHeight: this.new_partners_more ? `${height}` : '340px',
        overflow: 'hidden',
        transition: 'max-height 1s ease',
      }
    },
    names: () => names,
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      items: 'personal_account/partners/getPartners',
      itemsNewPartners: 'personal_account/partners/getNewPartners',
      count: 'personal_account/partners/getPartnersCount',
      isLoadingPartners: 'personal_account/partners/isLoadingPartners',
      isLoadingNewPartners: 'personal_account/partners/isLoadingNewPartners',
      getPartnersNext: 'personal_account/partners/getPartnersNext'
    }),
  },
  methods: {
    ...mapActions({
      loadPartners: 'personal_account/partners/loadPartners',
      loadNewPartners: 'personal_account/partners/loadNewPartners',
      loadPartnersTags: "selectors/loadPartnersTags",
      loadPartnersRegions: "selectors/loadPartnersRegions"
    }),
    addCover (items) {
      for (let i = 0; i < items.length; i++) {
        this.partners.push({ ...items[i], cover: true })
      }
      this.isLoading = false
      this.isSubLoading = false
    },
    loadData (url = undefined, appendParam = undefined, appendValue = undefined) {
      this.loadPartners({
        url: url,
        urlAppend: (url) => {
          if (appendParam) {
            return this.addGetParameter(this.addPageParameter(this.addSizeParameter(url)), appendParam, appendValue)
          } else {
            return this.addPageParameter(this.addSizeParameter(url))
          }
        },
        finalizer: (data, url) => {
          this.setCurrentLoadUrl(url)
          this.addCover(data.results)
        },
        catcher: () => {}
      })
    },
    loadNewPartnersData (url = undefined) {
      this.loadNewPartners({
        url: url,
        finalizer: (data, url) => {
          for (let i = 0; i < data.length; i++) {
            this.newPartners.push({ ...data[i], cover: true })
          }
        },
        catcher: () => {}
      })
    },
    loadNextItems () {
      if (this.getPartnersNext !== null) {
        this.isSubLoading = true
        const url = this.getPartnersNext
        const startIndex = url.indexOf("page=") + 5 // Получаем индекс символа после "page="
        this.pagination.need_reload = true
        this.pagination.page = url.slice(startIndex)
      }
    },
    loadSelectors () {
      this.loadPartnersTags({
        url: undefined,
        finalizer: (val) => {
          this.selectors.partnersTags = val
        }
      })
      this.loadPartnersRegions({
        url: undefined,
        finalizer: (val) => {
          this.selectors.partnersRegions = val
        }
      })
    },
    clickSearch () {
      if (this.search.value !== undefined && this.search_local_value !== this.search.value) {
        this.isLoading = true
        this.partners = []
        this.pagination.need_reload = true
        this.searchData()
        this.search_local_value = this.search.value
      }
    },
    openSearch () {
      this.search_panel = true
      this.$nextTick(() => {
        this.$refs['search-field-input'].focus()
      })
    },
    closeSearch () {
      this.isLoading = true
      this.partners = []
      this.search_panel = false
      this.search.value = ''
      this.pagination.need_reload = false
      this.pagination.page = 1
      this.$nextTick(() => {
        this.loadData()
      })
    },
    openFilter () {
      this.filter_panel = true
      this.$nextTick(() => {
        this.$refs['filter-field-input'].focus()
      })
    },
    clickFilter () {
      if (this.filters.tag) {
        this.partners = []
        this.pagination.filters.tag = this.filters.tag
        this.pagination.need_reload = true
        if (this.filter_panel) {
          this.$nextTick(() => {
            this.$refs['filter-field-input'].blur()
          })
        }
      }
    },
    closeFilter () {
      this.isLoading = true
      this.partners = []
      this.filter_panel = false
      this.filters.tag = null
      this.loadData()
    },
    filterPartnersToCategory (event) {
      if (event) {
        this.partners = []
        this.pagination.filters.tag = event
        this.pagination.need_reload = true
      } else {
        this.isLoading = true
        this.partners = []
        this.loadData()
      }
    },
    openRegion () {
      this.region_panel = true
      this.$nextTick(() => {
        this.$refs['region-field-input'].focus()
      })
    },
    clickRegion () {
      if (this.filters.region) {
        this.partners = []
        this.filters.home_region = null
        this.pagination.filters.home_region = null
        this.pagination.filters.region = this.filters.region
        this.pagination.need_reload = true
        if (this.filter_panel) {
          this.$nextTick(() => {
            this.$refs['region-field-input'].blur()
          })
        }
      }
    },
    closeRegion () {
      this.isLoading = true
      this.partners = []
      this.region_panel = false
      this.filters.region = null
      this.filters.home_region = null
      this.loadData()
    },
    filterPartnersToRegion (event) {
      if (event) {
        this.partners = []
        this.region_panel = false
        this.filters.region = null
        this.pagination.filters.region = null
        this.pagination.filters.home_region = event
        this.pagination.need_reload = true
      }
    },
  },
  created () {
    if (!this.isAuthenticated) {
      this.$router.push({ name: names.MAIN })
    } else {
      if (this.$route.query.tag) {
        this.loadData(undefined, 'tag', this.$route.query.tag)
      } else {
        this.loadData()
      }
      this.loadNewPartnersData()
      this.loadSelectors()
    }
  }
})
</script>

<style scoped lang="scss">
.partner__title {
  display: flex;
  justify-content: space-between;
}

.partner__title--text {
  padding: 0;
  margin-bottom: 30px;
  text-transform: uppercase;
  font-size: 20px;
  font-weight: 700;
  color: #34347C;
  text-align: left;

  &::before {
    margin-right: 28px;
    content: "";
    display: inline-block;
    width: 14px;
    height: 14px;
    background-color: #376FFE;
  }
}

.search__field {
  margin-top: -10px;
  display: flex;
  justify-content: flex-end;
  flex-wrap: nowrap;
  width: 500px;
}

.search__field_input {
  height: 50px;
}

.search__field_label {
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
}

.search_icon {
  cursor: pointer;
}

.partner__content {
  text-align: center;
  border-radius: 5px;
  width: 100%;
  background-color: white;
  padding: 25px 25px;
}

.partner__next {
  padding-top: 25px;
  padding-bottom: 25px;
}

.partner__next_btn {
  border-radius: 10px;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 22px;
  text-align: center;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #FFFFFF;
}

.filter-btn {
  font-size: 16px;
  line-height: 20px;
  margin: 10px 10px;
  border-radius: 5px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: white;

  @media (max-width: 600px) {
    margin: 5px 5px;
    font-size: 13px;
  }
}

@media screen and (max-width: 1280px) {
  .partner__content {
    padding: 0;
  }
}

@media screen and (max-width: 768px) {
  .partner__title {
    margin-top: 20px;
  }

  .partner__title--text {
    margin-bottom: 20px;
    font-size: 14px;
    line-height: 17px;

    &::before {
      margin-right: 20px;
      width: 10px;
      height: 10px;
    }
  }

  .search__field_input {
    height: 70px;
  }

  .search__field_label {
    font-size: 14px;
    line-height: 17px;
  }
}
</style>
